"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseWidgetHandler", {
    enumerable: true,
    get: function() {
        return BaseWidgetHandler;
    }
});
let BaseWidgetHandler = class BaseWidgetHandler {
    async validateWidgetData(..._args) {
        return [];
    }
    async getWidgetData(_params) {
        return {};
    }
    async formatValue(..._params) {
        return {};
    }
    async serializeOrDeserializeWidget(..._params) {
        return {};
    }
    extractDependencies(_widget) {
        return {
            columns: [],
            models: [],
            views: []
        };
    }
};
